module.exports = __webpack_public_path__ + "static/media/026.00d0c02b.jpg";